// App.tsx — نقطة تجميع المزوّدات (i18n / الهويّة+shadcn-Tailwind / المصادقة) + الموجّه المركزيّ.
// خطّ الواجهة: IBM Plex Sans (لاتينيّ) + IBM Plex Sans Arabic (عربيّ) — عبر @fontsource (مُستضاف
// ذاتيًّا، بلا اعتماد على شبكة خارجيّة كـGoogle Fonts CDN).
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-sans/700.css';
import '@fontsource/ibm-plex-sans-arabic/400.css';
import '@fontsource/ibm-plex-sans-arabic/500.css';
import '@fontsource/ibm-plex-sans-arabic/600.css';
import '@fontsource/ibm-plex-sans-arabic/700.css';
import './styles/index.css';
import { Suspense } from 'react';
import './lib/i18n';
import { SmartThemeProvider } from './theme/SmartThemeProvider';
import { AuthProvider } from './auth/AuthContext';
import { AppRouter } from './routes';
import { ErrorBoundary } from './components/ErrorBoundary';

export default function App() {
	return (
		<ErrorBoundary>
			<Suspense fallback={null}>
				<SmartThemeProvider>
					<AuthProvider>
						<AppRouter />
					</AuthProvider>
				</SmartThemeProvider>
			</Suspense>
		</ErrorBoundary>
	);
}
